import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import ExamFinishedScreenLayout from './ExamFinishedScreenLayout';
import RetakeExamButton from './RetakeExamButton';
import { getIsExamAttemptExpired } from '../examsUtils';
import { jsx as _jsx } from "react/jsx-runtime";
/* This scenario can occur when a user completes the exam _without_ first completing
 * the graded practical exercises. Then after the attempt expires after a year, they
 * complete the practical exercises, but are unable to receive a certificate as
 * it's been more than a year since the last exam attempt.
 */
const ExamAttemptExpiredScreen = ({
  track,
  mostRecentExamAttempt,
  pendingPracticalExercises
}) => {
  var _track$exam;
  const {
    attemptExpiresOn
  } = getIsExamAttemptExpired(mostRecentExamAttempt);
  return /*#__PURE__*/_jsx(ExamFinishedScreenLayout, {
    callToAction: /*#__PURE__*/_jsx(RetakeExamButton, {
      mostRecentExamAttempt: mostRecentExamAttempt,
      use: "primary"
    }),
    heading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.exams.finished.expiredAttempt"
    }),
    illustration: /*#__PURE__*/_jsx(Illustration, {
      name: "announcement"
    }),
    mostRecentExamAttempt: mostRecentExamAttempt,
    pendingPracticalExercises: pendingPracticalExercises,
    prompt: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.exams.finished.yourPreviousScoreWas",
      options: {
        correctQuestionCount: mostRecentExamAttempt && mostRecentExamAttempt.score,
        totalQuestionCount: track && ((_track$exam = track.exam) === null || _track$exam === void 0 ? void 0 : _track$exam.length) || 0
      }
    }),
    subheading: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "learningCenter.exams.finished.expiredAttemptSubheading",
      options: {
        expiryDate: /*#__PURE__*/_jsx(FormattedDateTime, {
          format: "ll",
          value: attemptExpiresOn
        })
      }
    }),
    track: track
  });
};
export default ExamAttemptExpiredScreen;